import { I18n } from "../services/I18n";
import "./generated/site-translations-nl";
import common_nl from "../../../../../libs/ps/restaumatic-common/locales/nl.json";
import core_types_sites_nl from "../../../../../libs/ps/restaumatic-core-types-sites/locales/nl.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  nl: { _core_types_sites: core_types_sites_nl },
});
I18n.translations = I18n.extend(I18n.translations, {
  nl: { _common: common_nl },
});
